import { gql } from "@apollo/client";

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($data: OrganizationInputData!) {
    createOrganization(data: $data) {
      id
      name
    }
  }
`;
